export const useBrowserInfo = () => {
   return navigator
}
